import utils from 'utils/lsp-utils-service';
import * as api from 'registration/resources/registration.api';
import actionTypes from './action-types';

export const mapSecurityQuestionsToArray = (questionA, questionB, answerA, answerB) => [
  {
    questionId: questionA,
    answer: answerA,
  },
  {
    questionId: questionB,
    answer: answerB,
  },
];

export const createUserDTO = (retailer, form, locale) => {
  const { retailerId, salts } = retailer;
  const { emailAddress, firstName, lastName, userValidation, questionA, questionB, answerA, answerB, ...requestData } = form;

  const hashedPins = userValidation !== '' ? utils.getHashes(userValidation, salts) : null;
  const pin = !hashedPins ? userValidation : undefined;

  const challenges = mapSecurityQuestionsToArray(questionA, questionB, answerA, answerB);

  const userValidationDto = {
    firstName,
    lastName,
    retailerId,
    email: emailAddress,
    hashedPins,
    pin,
  };

  return {
    userValidation: userValidationDto,
    firstName,
    lastName,
    emailAddress,
    challenges,
    locale,
    ...requestData,
  };
};

export const createAccountRequest = () => ({
  type: actionTypes.CREATE_ACCOUNT_REQUEST,
});

export const createAccountSuccess = () => ({
  type: actionTypes.CREATE_ACCOUNT_SUCCESS,
});

export const createAccountFailure = () => ({
  type: actionTypes.CREATE_ACCOUNT_FAILURE,
});

export const createAccount = (form) => async (dispatch, getState) => {
  try {
    const { registration, session } = getState();
    const { locale } = session;
    const { token } = form;
    const { retailer } = registration;
    const urlParams = { token };
    const user = createUserDTO(retailer, form, locale);
    dispatch(createAccountRequest());
    await api.createAccount(user, urlParams);
    dispatch(createAccountSuccess());
  } catch (error) {
    console.error('CREATE_ACCOUNT_FAILURE', error);
    dispatch(createAccountFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/registration/actions/create-account.actions.js